import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .title_wrapper_textfield {
    gap: 8px;
    display: flex;
    align-items: center;
    margin-bottom: .5rem;

    label {
    }
  }
  
  .file-input__input {
    opacity: 0;
    z-index: -1;
    width: 0.1px;
    height: 0.1px;
    overflow: hidden;
    position: absolute;
  }

  .file-input__label {
    width: 100%;
    font-size: 14px;
    cursor: pointer;
    font-size: 14px;
    color: #818181;
    font-weight: 600;
    border-radius: 5px;
    background: #FFF;
    padding: 10px 12px;
    border-radius: 4px;
    align-items: center;
    display: inline-flex;
    border: 1px dashed #000;
  }


  .file-input__label_preview {
    width: 100%;
    font-size: 14px;
    cursor: pointer;
    font-size: 14px;
    color: #818181;
    font-weight: 600;
    border-radius: 5px;
    background: #FFF;
    padding: 10px 12px;
    border-radius: 4px;
    align-items: center;
    display: inline-flex;
    border: 1px dashed #000;
  }

  .file-input__label:hover {
    background-color: rgba(66, 69, 168, 0.25);
  }

  .file-input__label svg {
    margin-right: 4px;
  }

  .error_wrapper {
    width: 100%;
    margin-top: .5rem;

    span {
      color: red;
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      font-style: normal;
    }
  }
`;